<div class="room">
    <div class="roomNumber-room">
        <div class="selected-room">
            <fa-icon *ngIf="selectedRoom" [icon]="iconCheck"></fa-icon>
        </div>

        <room-informations [room]="room"></room-informations>
    </div>

    <strong class="distribution">{{ travellersByRoom }}</strong>

    <div class="price-conditions">
        <div class="conditions">
            <request-status *ngIf="room.status === RoomStatus.Request"></request-status>

            <cancellation-conditions [penalty]="room.penalty"
                                     [dateLastCancellationWithoutPenalty]="room.dateLastCancellationWithoutPenalty"
                                     [previousPenalty]="oldRoom?.penalty"
                                     [currency]="currency"
                                     [price]="room?.unit?.cost || room?.total?.cost"
                                     [configSharedHotel]="configSharedHotel">
            </cancellation-conditions>

            <resort-fee *ngIf="resortFee"
                        [fee]="resortFee"
                        [currency]="currency"
                        [currencies]="currencies">
            </resort-fee>

            <meal-plan *ngIf="showMealPlan"
                       [name]="room.mealplan?.name?.text"
                       [code]="room.mealplan?.xCode">
            </meal-plan>

            <sales-information *ngIf="salesInformation"
                               [salesInformation]="salesInformation">
            </sales-information>
        </div>

        <div class="price">
            <ng-container *ngIf="room.unit">
                <ng-container *ngIf="showCostPricePermission">
                    <small *ngIf="showRetailPricePermission && room.unit.retail">{{wording.cost}}</small>
                    <price-details *ngIf="room.unit"
                                   [cost]="room.unit.cost"
                                   [currencies]="currencies">
                    </price-details>
                </ng-container>

                <ng-container *ngIf="showRetailPricePermission && room.unit.retail">
                    <small *ngIf="room.unit.cost && showCostPricePermission">{{wording.retail}}</small>
                    <price-details [cost]="room.unit.retail"
                                   [currencies]="currencies">
                    </price-details>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="!room.unit && room.total">
                <ng-container *ngIf="showCostPricePermission">
                    <small *ngIf="showRetailPricePermission && room.total.retail">{{wording.cost}}</small>
                    <price-details *ngIf="room.total"
                                   [cost]="room.total.cost"
                                   [currencies]="currencies">
                    </price-details>
                </ng-container>

                <ng-container *ngIf="showRetailPricePermission && room.total.retail">
                    <small *ngIf="room.total.cost && showRetailPricePermission">{{wording.retail}}</small>
                    <price-details [cost]="room.total.retail"
                                   [currencies]="currencies">
                    </price-details>
                </ng-container>
            </ng-container>

            <delta-price *ngIf="oldRoom"
                         [price]="room.unit.cost || room.total.cost"
                         [oldPrice]="oldRoom.unit.cost || oldRoom.total.cost"
                         [currency]="this.currency">
            </delta-price>
        </div>
    </div>
</div>